import "./style.scss";

import { FC } from "react";
import { Pricing } from "shared/config/pricings";
import { ReactComponent as IconCheck } from "assets/img/icons/icon_status-Checked.svg";

interface OffreAccompagnementLigneProps {
    plan: Pricing;
    /** Offre choisie par le client : une seule à la fois. */
    selectionnee: boolean;
    onSelect: () => void;
    /** Ouvre le détail de l'offre, dans une fenêtre. */
    onEnSavoirPlus: () => void;
}

/**
 * Une offre d'accompagnement, en ligne.
 *
 * La ligne se limite à ce qui permet de CHOISIR : la situation à laquelle
 * l'offre répond, son prix, et ce que le prix comprend. Le détail complet vit
 * dans la fenêtre « en savoir plus », pour que la liste reste comparable d'un
 * coup d'œil.
 */
const OffreAccompagnementLigne: FC<OffreAccompagnementLigneProps> = ({
    plan, selectionnee, onSelect, onEnSavoirPlus,
}) => (
    <div
        className={`OffreLigne ${selectionnee ? "OffreLigne--selectionnee" : ""} ${plan.miseEnAvant ? "OffreLigne--avant" : ""}`}
        onClick={onSelect}
        role="radio"
        aria-checked={selectionnee}
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onSelect(); } }}
        data-testid={`offre-${plan.offreId}`}>

        {plan.miseEnAvant && <span className="OffreLigne__avant">{plan.miseEnAvant}</span>}

        <span className={`OffreLigne__radio ${selectionnee ? "OffreLigne__radio--active" : ""}`} aria-hidden="true" />

        <div className="OffreLigne__corps">
            {/* Pastille et titre sur la MÊME ligne : les trois offres doivent
                tenir à l'écran sans défilement. */}
            <div className="OffreLigne__entete">
                <h4 className="OffreLigne__titre">{plan.title}</h4>
                {plan.badge && <span className="OffreLigne__badge">{plan.badge}</span>}
            </div>

            {plan.accroche && <p className="OffreLigne__accroche">{plan.accroche}</p>}

            <div className="OffreLigne__pied">
                {plan.inclus && (
                    <span className="OffreLigne__inclus">
                        <IconCheck className="OffreLigne__check" />
                        {plan.inclus.title}
                    </span>
                )}
                {/* `stopPropagation` : consulter le détail ne vaut pas choix de l'offre. */}
                <button
                    type="button"
                    className="OffreLigne__lien"
                    onClick={(e) => { e.stopPropagation(); onEnSavoirPlus(); }}>
                    en savoir plus
                </button>
            </div>
        </div>

        <div className="OffreLigne__tarif">
            <span className="OffreLigne__prix">{plan.price} €</span>
            {plan.uniteTarif && <span className="OffreLigne__unite">/ {plan.uniteTarif}</span>}
        </div>
    </div>
);

export default OffreAccompagnementLigne;
